/**
 * When the user picks a new postcode `basic_coverage_postcode_validation_contents`
 * might be truthy as it was in the previous postcode. Since we set `main_modules2` to
 * `false` when a postcode was changed to trigger quote properly, we need to check if
 * postcode was changed and a validation has been passed again.
 */
export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (quote) => {
      const inputState = kasko.getState('input');

      const contentsValidation = quote.data?.extraData?.basic_coverage_postcode_validation_contents;
      const buildingsValidation =
        quote.data?.extraData?.basic_coverage_postcode_validation_building;

      if (!inputState.postcode_changed || (!contentsValidation && !buildingsValidation)) {
        return;
      }

      const modules = {};
      if (contentsValidation) {
        modules.main_modules2 = true;
      }
      if (buildingsValidation) {
        modules.fire_basic_coverage = true;
      }

      kasko.dispatchEvent('set-state-input', {
        postcode_changed: false,
        ...modules,
      });
      kasko.dispatchEvent('set-form-input', {
        ...modules,
      });
    },
    { slice: 'quote' },
  );
};
